const baseRoute = 'document-manager/:moduleBridgeHex/';
export default {
  user_module_documentManager_item_list: {
    path: `${baseRoute}item/list/:parentItemHex/:page/:filtersHex/`,
    parameters: {
      moduleBridgeHex: undefined,
      parentItemHex: 0,
      page: 1,
      filtersHex: 0,
    },
  },
  user_module_documentManager_pendingItem_list: {
    path: `${baseRoute}pending-item/list/`,
    parameters: {
      moduleBridgeHex: undefined,
    },
  },
  user_module_documentManager_tag_list: {
    path: `${baseRoute}tag/list/`,
    parameters: {
      moduleBridgeHex: undefined,
    },
  },
  user_module_documentManager_log_list: {
    path: `${baseRoute}log/list/:page/:filtersHex/`,
    parameters: {
      moduleBridgeHex: undefined,
      page: 1,
      filtersHex: 0,
    },
  },
  user_module_documentManager_cover_redirect: {
    path: `${baseRoute}cover/redirect/`,
    parameters: {
      moduleBridgeHex: undefined,
    },
  },
  user_module_documentManager_cover: {
    path: `${baseRoute}cover/`,
    parameters: {
      moduleBridgeHex: undefined,
    },
  },
};
